// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.import-device-configuration-container{
    position: absolute;
    top: 17vh;
    left: 11vw;
    width: 35vw;
    border-radius: 10px;
    background-color: white;
    box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.5);
}
.import-device-configuration-header{
    padding: 15px;
    display: flex;
    color: white;
    justify-content: space-between;
    border-radius: 10px 10px 0px 0px;
    background-color: rgba(155, 30, 30, 0.952);
}
.import-device-configuration-header h3{
    margin: 0px;
    font-weight: lighter;
}
.import-device-configuration-header p{
    margin: 0px;
    cursor: pointer;
}
.import-device-configuration-body{
    display: flex;
    justify-content: center;
    padding: 40px 0px;
}
.import-device-configuration-body select{
    width: 80%;
}
.import-device-configuration-buttons-container{
    display: flex;
    margin: 15px 30px;
    justify-content: space-between;
}
.import-device-configuration-buttons-container button{
    border: none;
    color: white;
    cursor: pointer;
    padding: 6px 15px;
    border-radius: 5px;
    transition: opacity 0.5s ease;
    background-color: rgba(155, 30, 30, 0.952);
}
.import-device-configuration-buttons-container button:hover{
    opacity: 0.9;
}`, "",{"version":3,"sources":["webpack://./src/styles/workspace_styles/TenantAdministratorStyles/Devices/ImportConfiguration.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,WAAW;IACX,mBAAmB;IACnB,uBAAuB;IACvB,0CAA0C;AAC9C;AACA;IACI,aAAa;IACb,aAAa;IACb,YAAY;IACZ,8BAA8B;IAC9B,gCAAgC;IAChC,0CAA0C;AAC9C;AACA;IACI,WAAW;IACX,oBAAoB;AACxB;AACA;IACI,WAAW;IACX,eAAe;AACnB;AACA;IACI,aAAa;IACb,uBAAuB;IACvB,iBAAiB;AACrB;AACA;IACI,UAAU;AACd;AACA;IACI,aAAa;IACb,iBAAiB;IACjB,8BAA8B;AAClC;AACA;IACI,YAAY;IACZ,YAAY;IACZ,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,6BAA6B;IAC7B,0CAA0C;AAC9C;AACA;IACI,YAAY;AAChB","sourcesContent":[".import-device-configuration-container{\r\n    position: absolute;\r\n    top: 17vh;\r\n    left: 11vw;\r\n    width: 35vw;\r\n    border-radius: 10px;\r\n    background-color: white;\r\n    box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.5);\r\n}\r\n.import-device-configuration-header{\r\n    padding: 15px;\r\n    display: flex;\r\n    color: white;\r\n    justify-content: space-between;\r\n    border-radius: 10px 10px 0px 0px;\r\n    background-color: rgba(155, 30, 30, 0.952);\r\n}\r\n.import-device-configuration-header h3{\r\n    margin: 0px;\r\n    font-weight: lighter;\r\n}\r\n.import-device-configuration-header p{\r\n    margin: 0px;\r\n    cursor: pointer;\r\n}\r\n.import-device-configuration-body{\r\n    display: flex;\r\n    justify-content: center;\r\n    padding: 40px 0px;\r\n}\r\n.import-device-configuration-body select{\r\n    width: 80%;\r\n}\r\n.import-device-configuration-buttons-container{\r\n    display: flex;\r\n    margin: 15px 30px;\r\n    justify-content: space-between;\r\n}\r\n.import-device-configuration-buttons-container button{\r\n    border: none;\r\n    color: white;\r\n    cursor: pointer;\r\n    padding: 6px 15px;\r\n    border-radius: 5px;\r\n    transition: opacity 0.5s ease;\r\n    background-color: rgba(155, 30, 30, 0.952);\r\n}\r\n.import-device-configuration-buttons-container button:hover{\r\n    opacity: 0.9;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
